import { biggerOrTo, translateInfluencer } from '../../render-helper';

export default [
  {
    header: 'Time',
    render: 'time',
  },
  {
    header: 'Influencer Tier',
    render: 'name',
    renderHelper: [translateInfluencer],
  },
  {
    header: 'Counts',
    render: 'value',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  },
];
